import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});

export default useStyles;
